import Page from 'modules/Page';
import lazyWithSuspense from 'modules/lazyWithSuspense';
import makePage from 'modules/makePage';
import { i18n } from 'i18n';
import { Permission } from 'providers/authorisation';
import { partial } from 'ramda';
import * as parentConstants from '../../constants';
import * as constants from './constants';
import { EditProjectPageParams } from './constants';
import useEditProjectQueries, { EditProjectQueries } from './useEditProjectQueries';

const EditProjectPage = lazyWithSuspense(() => import('./EditProjectPage'));

const page: Page<EditProjectPageParams> = {
  title: constants.TITLE,
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  authorise: (context, params) => ({
    handler: partial(context.functions.validatePermission, [Permission.ManageNodeData]),
    teamId: params.entityId ?? '',
  }),
  component: makePage<EditProjectPageParams, EditProjectQueries>({
    WrappedPage: EditProjectPage,
    titleFn: ([project]) => (project.data ? i18n._('Edit').concat(` ${project.data.name}`) : ''),
    parentPathTemplate: parentConstants.DETAILS_ROUTE_PATH,
    parentTitleFn: () => i18n._(parentConstants.DETAILS_TITLE),
    pageDataHook: useEditProjectQueries,
  }),
};

export default page;
